import React, { useState, useEffect, useRef } from 'react'
import ImageIcon from '@mui/icons-material/Image'
import Box from '@mui/material/Box'
import Table from '@mui/material/Table'

import Tooltip from '@mui/material/Tooltip';
import TableContainer from '@mui/material/TableContainer'
import DeleteForeverIcon from '@mui/icons-material/DeleteForever'
import { useDispatch } from 'react-redux'
import Typography from '@mui/material/Typography'
import notification1 from '../images/agente.svg'
import notification2 from '../images/cliente.svg'
import CheckIcon from '@mui/icons-material/Check'
import {getRoleUserIdFromToken, toBase64} from '../utils'
import AppBar from '../components/app-bar'
import { CircularProgress, Button, makeStyles, Select, TextField, Checkbox, IconButton } from '@material-ui/core'
import { customTheme } from '../styling'
import axios from '../axios'
import moment from 'moment'
import GeneralError from '../components/error'
import SnackBar from '../components/snackbar'
import { INTERNAL_SERVER_ERROR_MESSAGE } from '../constants'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import InfiniteScroll from 'react-infinite-scroll-component'



const useStyles = makeStyles((theme) => ({
    generateCodeContainer: {
        width: '100%',
        marginTop: '1.5rem',
    },
    appBarSpacer: theme.mixins.toolbar,
    uploadFile: {
        display: 'flex',
        flexDirection: 'column',
        overflowY: 'auto',
        overflowX: 'hidden',
        marginLeft: '1rem',
        width: '90%',
        height: '20vh',
        display: 'flex',
        textAlign: 'center',
        border: `1px solid ${customTheme.colors.ui.grey}`,
        borderStyle: 'dotted',
        marginBottom: '0.3rem'
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing(3),
        height: '100vh',
        overflow: 'auto',
    },
    title: {
        color: 'black',
    },
    selectBoxMain: {
        width: '80vw',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-evenly',
        position: 'absolute',
        top: '40%',
        cursor: 'pointer'
    },
    selectBox: {
        width: '35%',
        backgroundColor: customTheme.colors.ui.ligthBlue,
        padding: '1.5rem 3.5rem',
        textAlign: 'center',
        '&:hover': {
            cursor: 'pointer',
            opacity: '0.8'
        },
    },
    loadingContainer: {
        position: 'absolute',
        top: '50%',
        left: '50%'
    },
    formControl: {
        minWidth: 300, marginRight: '1.5rem'
    },
    dialogActions: {
        marginTop: '1rem'
    },
    contentContainer: {
        padding: '2rem'
    },
    textarea: {
        fontSize: '1rem',
        border: '1px solid #000',
        paddingLeft: '0.5rem',
        paddingTop: '0.5rem',
        resize: 'none',
        width: '100%',
        borderRadius: '8px',
        height: '30vh',
        '&:focus': {
            outline: 'none !important',
            outlineColor: customTheme.colors.ui.grey,
            border: `1px solid ${customTheme.colors.ui.grey} !important`
        },
    },

}))



function Item(props) {
    const { sx, ...other } = props;
    return (
        <Box
            sx={[
                (theme) => ({
                    bgcolor: '#fff',
                    color: 'grey.800',
                    border: '1px solid',
                    borderColor: 'grey.300',
                    p: 1,
                    m: 1,
                    borderRadius: 2,
                    fontSize: '0.875rem',
                    fontWeight: '700',
                    ...theme.applyStyles('dark', {
                        bgcolor: '#101010',
                        color: 'grey.300',
                        borderColor: 'grey.800',
                    }),
                }),
                ...(Array.isArray(sx) ? sx : [sx]),
            ]}
            {...other}
        />
    );
}
function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}


const Dashboard = () => {
    const history = useHistory()
    const dispatch = useDispatch()
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(false)
    const [addProductOpen, setAddProductOpen] = useState(false)
    const [description, setDescription] = useState(null)
    const [instructions, setInstructions] = useState(null)
    const [notifications, setNotifications] = useState([])
    const [nameProduct, setNameProduct] = useState(null)
    const inputRef = useRef(null)
    const [productTypes, setProductTypes] = useState([])
    const [productOpen, setProductOpen] = useState(null)
    const [price, setPrice] = useState(null)
    const classes = useStyles()
    const roleUserId = getRoleUserIdFromToken()
    const { enqueueSnackbar } = SnackBar.Consumer()
    const [currentInputSearch, setCurrentInputSearch] = useState('')
    const [category, setCategory] = useState(0)
    const [loadingNotification, setLoadingNotification] = useState(false)
    const [notificationsChecked, setNotificationsChecked] = useState([])
    const [hasNextPage, setHasNextPage] = useState(false)
    const [loadingMore, setLoadingMore] = useState(false)
    const [after, setAfter] = useState(false)
    const first = 30
    

    const getNotifications = async (input = null, afterQuery = 0) => {
        let url 
        if(roleUserId === 2){
           url = `/get-list-orders?orderBy=notificationAgentOn&direction=DESC&submittedBy=3&first=${first}&after=${afterQuery}&archived=0`
        }else{
            url = `/get-list-orders?orderBy=notificationOn&direction=DESC&first=${first}&after=${afterQuery}&archived=0`
        }
        

        const notifications = await axios.get(url)

        return notifications.data
    }

    const getProductTypes = async () => {
        let url = '/get-list-product-types'

        const productTypes = await axios.get(url)
        return productTypes.data
    }

    const getInitialData = async () => {
        const notifications = await getNotifications()
        const productTypes = await getProductTypes()
        return { notifications, productTypes }
    }

    useEffect(() => {
        setLoading(true)
        getInitialData().then((res) => {
            setNotifications(res.notifications.listOrders)
            setHasNextPage(res.notifications.hasNextPage)
        }).catch((error) => {
            console.log(error)
            setError(true)
        }).finally(() => {
            setLoading(false)
        })
    }, [category])

    const handleNotification = async () => {
        setLoadingNotification(true)
        const body = {
            orderIds:notificationsChecked
        }
        if(roleUserId === 2){
            body.isAgentNotification = 1
        }else{

        }
        await axios.post('/update-order-notification', body)

        dispatch({
            type: 'NOTIFICATION_CHANGED',
        })
        getInitialData().then((res) => {
            setNotifications(res.notifications.listOrders)
        }).catch((error) => {
            console.log(error)
            enqueueSnackbar({variant:'error', message:INTERNAL_SERVER_ERROR_MESSAGE})
        }).finally(() => {
            setLoadingNotification(false)
        })
    }

    const handleFetchMore = () => {
        setLoadingMore(true)
        setAfter(after + 30)
        getNotifications(after + 30).then((res) => {
            setLoadingMore(false)
            setHasNextPage(res.hasNextPage)
            setNotifications([...notifications, ...res.listOrders])
        }).catch((error) => {
            console.log('error', error)
            setLoadingMore(false)
            enqueueSnackbar(INTERNAL_SERVER_ERROR_MESSAGE, {
                variant: 'error',
            })
        })
    }

    const handleDeleteNotification = async (notId) => {
        setLoading(true)
        const body = {
            id:notId
        }
        if(roleUserId === 2){
            body.isAgentNotification = 1
        }else{

        }

        try {
            
            await axios.post('/delete-notification', body)

            dispatch({
                type: 'NOTIFICATION_CHANGED',
            })
            setNotifications(notifications.filter(({id}) => id !== notId))

        } catch (error) {
            enqueueSnackbar({variant:'error', message:INTERNAL_SERVER_ERROR_MESSAGE})
        }finally{
            setLoading(false)
        }
        
        
        
    }

   

    return (
        <AppBar>


            {error ? <GeneralError /> : loading ?
                <main className={classes.content}>
                    <div className={classes.appBarSpacer} />
                    <Typography className={classes.title} variant="h5" gutterBottom component="h2">
                        Notifiche
                    </Typography>

                    <Box className={classes.loadingContainer}>
                        <CircularProgress />
                    </Box>
                </main>
                :
                <main className={classes.content}>
                    <>
                        <div className={classes.appBarSpacer} />

                        <Typography style={{ float: 'left' }} className={classes.title} variant="h5" gutterBottom component="h2">
                            Notifiche
                        </Typography>
                        <Button onClick={() => notificationsChecked.length && handleNotification()} disabled={!notificationsChecked.length} variant='contained' style={{float:'right', width:'12rem'}}>{loadingNotification ? <CircularProgress size={20} /> : 'Segna come letto'}</Button>
                      
                       
                        <TableContainer style={{ marginTop: '4rem', }}>
                        <InfiniteScroll
                                height={'70vh'}
                                style={{ width: '100%' }}
                                dataLength={notifications.length}
                                next={handleFetchMore}
                                hasMore={hasNextPage}

                            >
                                <Table aria-label="simple table">
                                    <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(1, 1fr)'}}>
                                        {notifications.map((notification) => {
                                            return (
                                                <Item key={notification.id} style={{ backgroundColor:(roleUserId === 2 && notification.notificationAgentOn === 1) ? customTheme.colors.ui.greyLight : notification.notificationOn === 1 && customTheme.colors.ui.greyLight,  padding: '1.5rem', boxShadow: '0px 4px 4px rgba(0,0,0,0.2)', }}>
                                                    {notification.submittedBy === 2 ? <img style={{float:'left', marginRight:'1rem', width:'1.2rem'}} src={notification1} /> : <img style={{float:'left', marginRight:'1rem', width:'1.5rem'}} src={notification2} />}
                                                    {notification.submittedBy === 2 ?
                                                        <Typography style={{float: 'left',  position:'relative', top:'0.4rem', width:'60%', fontSize:'0.9rem'}}>
                                                            L’agente {notification.client.user.firstName} ha inoltrato un ordine per il cliente {notification.client.nameCompany} il {moment(notification.createdAt).format('DD-MM-YYYY')} alle {moment(notification.createdAt).format('hh:mm')}.
                                                        </Typography>
                                                    : notification.client.agent ? <Typography style={{position:'relative', top:'0.4rem', float: 'left', width:'60%', fontSize:'0.9rem'}}>Il cliente {notification.client.firstName} dell’agente {notification.client.user.firstName} ha effettuato un ordine il {moment(notification.createdAt).format('YYYY-MM-DD')} alle {moment(notification.createdAt).format('hh:mm')}.</Typography>
                                                    : <Typography style={{ position:'relative', top:'0.4rem', float: 'left', width:'60%', fontSize:'0.9rem'}}>Il cliente {notification?.client?.nameCompany} ha effettuato un ordine il {moment(notification.createdAt).format('YYYY-MM-DD')} alle {moment(notification.createdAt).format('hh:mm')}.</Typography>
                                                    }
                                                    <Box style={{ display:'flex', flexDirection:'row', float:'right',}}>
                                                        <Typography onClick={() => history.push(`/dashboard?id=${notification.id}`)} style={{ marginRight: '1rem', textDecoration: 'underline', cursor: 'pointer', position:'relative', top:'0.4rem' }}>Visualizza i dettagli dell'ordine  </Typography>
                                                        {roleUserId === 2 ? notification.notificationAgentOn === 1 ?
                                                            <Checkbox style={{width:'3rem', height:'1rem', position:'relative', top:'0.5rem'}} checked={notificationsChecked.includes(notification.id)} onClick={() => {
                                                            if(notificationsChecked.includes(notification.id)){
                                                                setNotificationsChecked(notificationsChecked.filter((id) => notification.id !== id))
                                                            }else{
                                                                setNotificationsChecked([...notificationsChecked, notification.id])
                                                            }
                                                            
                                                        }} color='primary' /> : <Box><CheckIcon style={{width:'2.8rem', position:'relative', top:'0.2rem'}} />
                                                        <Tooltip title="Elimina notifica">
     
      <DeleteForeverIcon onClick={() => handleDeleteNotification(notification.id)} style={{width:'2.8rem', position:'relative', top:'0.2rem', cursor:'pointer', color:customTheme.colors.ui.red}} />
    
    </Tooltip>
                                                        </Box>
                                                         : notification.notificationOn === 1 ? <Checkbox style={{width:'3rem', height:'1rem', position:'relative', top:'0.5rem'}} checked={notificationsChecked.includes(notification.id)} onClick={() => {
                                                            if(notificationsChecked.includes(notification.id)){
                                                                setNotificationsChecked(notificationsChecked.filter((id) => notification.id !== id))
                                                            }else{
                                                                setNotificationsChecked([...notificationsChecked, notification.id])
                                                            }
                                                            
                                                        }} color='primary' /> : <Box><CheckIcon style={{width:'2.8rem', position:'relative', top:'0.2rem'}} />   <Tooltip title="Elimina notifica">
                                                        <DeleteForeverIcon onClick={() => handleDeleteNotification(notification.id)} style={{width:'2.8rem', position:'relative', top:'0.2rem', cursor:'pointer', color:customTheme.colors.ui.red}} />
                                                       
                                                      </Tooltip></Box>}
                                                    </Box>
                                                   

                                                </Item>

                                            )
                                        })}




                                    </Box>
                                </Table>


                                </InfiniteScroll>
                                {loadingMore && <h4 className={classes.loadingMessage}>Caricamento...</h4>}
                        </TableContainer>

                    </>


                </main >
            }
        </AppBar >
    )
}

export default Dashboard